import { render, staticRenderFns } from "./DashboardMobile.vue?vue&type=template&id=bab085b2&scoped=true&"
import script from "./DashboardMobile.vue?vue&type=script&lang=js&"
export * from "./DashboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMobile.vue?vue&type=style&index=0&id=bab085b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab085b2",
  null
  
)

export default component.exports